import { render, staticRenderFns } from "./CourseCard.vue?vue&type=template&id=4af43d8c&scoped=true&"
import script from "./CourseCard.vue?vue&type=script&lang=js&"
export * from "./CourseCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseCard.vue?vue&type=style&index=0&id=4af43d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af43d8c",
  null
  
)

export default component.exports